$(function() {
    'use strict';

    $('.article-list .size-options li').click(function() {
        var size = $(this).attr('data-value');
        Cookies.set('article-list-size', size, {
            expires: 30,
            path: '/'
        });
        location.reload();
    });
});
